import { Paper, TextField, Button, CircularProgress } from '@mui/material';

const AnalyticsFilters = ({ dateFrom, setDateFrom, dateTo, setDateTo, loading, onApply }) => (
  <Paper sx={{ p: 2, mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
    <TextField size="small" type="date" label="From" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} InputLabelProps={{ shrink: true }} />
    <TextField size="small" type="date" label="To" value={dateTo} onChange={(e) => setDateTo(e.target.value)} InputLabelProps={{ shrink: true }} />
    <Button variant="contained" onClick={onApply} disabled={loading} sx={{ bgcolor: '#0d3c61', '&:hover': { bgcolor: '#0a2d4a' } }}>
      {loading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Apply'}
    </Button>
  </Paper>
);

export default AnalyticsFilters;
